import { mapState, mapActions } from 'vuex';
import { Money } from 'v-money';

import {
  FORMA_ALUGUEL,
  INDICE_REAJUSTE,
  REGRA_REPASSE,
  PERFIL_CLIENTE_ITEM_RECIBO,
  TIPO_ITEM_RECIBO,
  PATH_LOGOS,
  AUTH_MODE_ZAP_SIGN
} from "../../util/constantes.js";

import Util from "../../util/funcoes.js";

import AppAdicionarItemAoReciboDialog from "./dialogs/AdicionarItemAoReciboDialog.vue";
import AppAlterarLogoImobiliariaDialog from './dialogs/AlterarLogoImobiliariaDialog.vue';
import DialogPersonalizarEmailAniversario from './dialogs/PersonalizarEmailAniversarioDialog.vue';
import DialogPersonalizarEmailCampanha from './dialogs/PersonalizarEmailCampanhaDialog.vue'
import DialogConfiguracoesEmailPesquisa from "./dialogs/ConfiguracoesEmailPesquisa.vue";

export default {
  components: {
    AppAdicionarItemAoReciboDialog,
    AppAlterarLogoImobiliariaDialog,
    DialogPersonalizarEmailAniversario,
    DialogPersonalizarEmailCampanha,
    DialogConfiguracoesEmailPesquisa,
    Money,
  },

  data() {
    return {
      visibilidadeAdicionarItemAoReciboDialog: false,
      dialogAlterarLogoImobiliariaIsVisible: false,
      isVisibleDialogPersonalizarEmailAniversario: false,
      isVisibleDialogPersonalizarEmailCampanha: false,
      isVisibleDialogConfiguracoesEmailPesquisa: false,

      tabSelecionada: 'contratos',

      percent: {
        decimal: ',',
        precision: 2,
        masked: false,
        suffix: '%',
      },

      percentAM: {
        decimal: ',',
        precision: 2,
        masked: false,
        suffix: '% a.m.',
      },

      pathLogoImobiliaria: '',
      updateParam: 0,

      hoverGravar: false,

      alugueisAvisoAtivoSelecionados: [],
      alugueisDisponiveisSelecionados: []
    };
  },

  created() {
    this.handleRecuperarParametros();
    this.configurarThumbnailLogoImobiliariaInicial();
    this.handleListarAlugueis();
  },

  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; },
      isSuporte(state){return state.usuarioLogado.suporte;},
    }),

    ...mapState('parametrosStore', {
      parametros(state) { return state.parametros },
      alugueisAprovados(state) { return state.alugueisAprovados }
    }),

    formasAluguel() { return FORMA_ALUGUEL },
    indicesReajuste() { return INDICE_REAJUSTE },
    regrasRepasse() { return REGRA_REPASSE },
    perfisCliente() { return PERFIL_CLIENTE_ITEM_RECIBO },
    tiposItem() { return TIPO_ITEM_RECIBO },
    util() { return Util },

    exibirControleEmails() {
      return this.exibirControleAvisoVencimentoProximo || this.exibirControleAvisoAposVencimento || this.exibirControleAcompanhamentoImovel || this.exibirControleEmailAniversario;
    },
    exibirControleAvisoVencimentoProximo() {
      return this.usuarioLogado.imobiliaria.avisoVencimentoProximo
    },
    exibirControleAvisoAposVencimento() {
      return this.usuarioLogado.imobiliaria.avisoAposVencimento
    },
    exibirControleAcompanhamentoImovel() {
      return this.usuarioLogado.imobiliaria.emailAcompanhamentoImovel
    },
    exibirControleEmailAniversario() {
      return this.usuarioLogado.imobiliaria.emailAniversario;
    },
    alugueisDisponiveis() {
      return this.alugueisAprovados.filter(item => !item.isEnviarAvisoIptu);
    },
    alugueisAvisoIptuAtivado() {
      const alugueisAvisoIptuAtivado = this.alugueisAprovados.filter(item => item.isEnviarAvisoIptu)
      
      return alugueisAvisoIptuAtivado;
    },
    authModes() {
      return AUTH_MODE_ZAP_SIGN
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapActions('parametrosStore', [
      'recuperarParametros',
      'gravarParametros',
      'removerItemReciboAutomatico',
      'listarAlugueis',
      'atualizarValorIsEnviarAvisoIptu'
    ]),

    handleRecuperarParametros() {
      const payload = {};
      this.showLoading();

      this.recuperarParametros(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleListarAlugueis() {
      const payload = {
        status: 'APROVADO',
        pagina: -1
      }

      this.listarAlugueis(payload).then().catch(() => {
        this.$message.error("Erro ao listar Alugueis, não foi possível conectar-se ao servidor.")
      })
    },

    gravarHandler() {
      this.showLoading();

      const payload = {
        ...this.parametros,
        alugueisAtivarAvisoIptu: this.alugueisAvisoIptuAtivado 
      }
      if(payload.formaAluguel === ''){
        delete payload.formaAluguel;
      }

      this.gravarParametros(payload).then(resultado => {
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    selecionarAluguelAtivo(val) {
      if(this.alugueisAvisoAtivoSelecionados.includes(val)) {
        const index = this.alugueisAvisoAtivoSelecionados.findIndex(item => item.id === val.id);
        this.alugueisAvisoAtivoSelecionados.splice(index, 1);
      } else {
        this.alugueisAvisoAtivoSelecionados.push(val);
      }
    },

    marcarTodosAluguelAtivo() {
      for(let i = 0; i < this.alugueisAvisoIptuAtivado.length; i++) {
        if(!this.alugueisAvisoAtivoSelecionados.includes(this.alugueisAvisoIptuAtivado[i])) {
          this.alugueisAvisoAtivoSelecionados.push(this.alugueisAvisoIptuAtivado[i]);
        }
      }
    },

    desmarcarTodosAluguelAtivo() {
      this.alugueisAvisoAtivoSelecionados = []
    },

    selecionarAluguelDisponivel(val) {
      if(this.alugueisDisponiveisSelecionados.includes( val)) {
        const index = this.alugueisDisponiveisSelecionados.findIndex(item => item.id === val.id);
        this.alugueisDisponiveisSelecionados.splice(index, 1);
      } else {
        this.alugueisDisponiveisSelecionados.push(val);  
      }
      
    },
    
    marcarTodosAluguelDisponivel() {
      for(let i = 0; i < this.alugueisDisponiveis.length; i++) {
        if(!this.alugueisDisponiveisSelecionados.includes(this.alugueisDisponiveis[i])) {
          this.alugueisDisponiveisSelecionados.push(this.alugueisDisponiveis[i]);
        }
      }
    },

    desmarcarTodosAluguelDisponivel() {
      this.alugueisDisponiveisSelecionados = []
    },

    tableRowClassNameAlugueisAvisoAtivo({ row }) {
      return this.alugueisAvisoAtivoSelecionados.includes(row) ? 'selected-row' : '';
    },

    tableRowClassNameAlugueisDisponiveis({ row }) {
      return this.alugueisDisponiveisSelecionados.includes(row) ? 'selected-row' : '';
    },

    adicionarAlugueisAosAtivos() {
      this.atualizarValorIsEnviarAvisoIptu(this.alugueisDisponiveisSelecionados);

      this.alugueisDisponiveisSelecionados = [];
    },

    adicioarAlugueisAosDisponiveis() {
      this.atualizarValorIsEnviarAvisoIptu(this.alugueisAvisoAtivoSelecionados);

      this.alugueisAvisoAtivoSelecionados = [];
    },

    configurarThumbnailLogoImobiliaria(nomeArquivo) {
      this.pathLogoImobiliaria = `${PATH_LOGOS}${nomeArquivo}?u=${++this.updateParam}`;
    },
    
    configurarThumbnailLogoImobiliariaInicial() {
      const nomeArquivo = this.usuarioLogado.imobiliaria.logo;
      this.configurarThumbnailLogoImobiliaria(nomeArquivo);
    },

    removerItemRecibo(itemRecibo) {
      this.removerItemReciboAutomatico(itemRecibo);
    },

    handleClickButtonAlterarLogoImobiliaria() {
      this.exibirDialogAlterarLogoImobiliaria();
    },
    handleClickButtonPersonalizarEmailAniversario() {
      this.exibirDialogPersonalizarEmailAniversario();
    },
    handleClickButtonPersonalizarEmailCampanha() {
      this.exibirDialogPersonalizarEmailCampanha();
    },
    exibirAdicionarItemAoReciboDialog() {
      this.visibilidadeAdicionarItemAoReciboDialog = true;
    },
    fecharAdicionarItemAoReciboDialog() {
      this.visibilidadeAdicionarItemAoReciboDialog = false;
    },
    
    exibirDialogAlterarLogoImobiliaria() {
      this.dialogAlterarLogoImobiliariaIsVisible = true;
    },
    fecharDialogAlterarLogoImobiliaria() {
      this.dialogAlterarLogoImobiliariaIsVisible = false;
    },
    alterarLogoImobiliaria(resultado) {
      const nomeArquivo = resultado.item.logo;
      this.configurarThumbnailLogoImobiliaria(nomeArquivo);

      this.dialogAlterarLogoImobiliariaIsVisible = false;
    },

    exibirDialogPersonalizarEmailAniversario() {
      this.isVisibleDialogPersonalizarEmailAniversario = true;
    },
    fecharDialogPersonalizarEmailAniversario() {
      this.isVisibleDialogPersonalizarEmailAniversario = false;
    },

    exibirDialogPersonalizarEmailCampanha() {
      this.isVisibleDialogPersonalizarEmailCampanha = true;
    },
    fecharDialogPersonalizarEmailCampanha() {
      this.isVisibleDialogPersonalizarEmailCampanha = false;
    },
    exibirDialogConfiguracoesEmailPesquisa() {
      this.isVisibleDialogConfiguracoesEmailPesquisa = true;
    },

    fecharDialogConfiguracoesEmailPesquisa() {
      this.isVisibleDialogConfiguracoesEmailPesquisa = false;
    }
  }
}